import { atomWithStorage } from 'jotai/utils';
import { MMKV } from 'react-native-mmkv';
import { parseOrNull } from '@/utils/JSON';
export const storage = new MMKV();
export function getStorageValue(key) {
    const value = storage.getString(key);
    return value ? parseOrNull(value) : null;
}
export function atomForLocal(atomKey) {
    const valueStore = {
        getItem: key => getStorageValue(key),
        setItem: (key, value) => {
            storage.set(key, JSON.stringify(value));
        },
        removeItem: key => {
            storage.delete(key);
        },
    };
    // getOnInit: hydrate synchronously from storage at init (matches
    // atomForLocalNonNull). Without it, the first render sees `null` before the
    // storage value loads, so token-gated initial routing (Intro/Main) wrongly
    // redirects logged-in users to Login — visible on web where the timing differs.
    return atomWithStorage(atomKey, null, valueStore, {
        getOnInit: true,
    });
}
export function atomForLocalNonNull(atomKey, defaultValue) {
    const valueStore = {
        getItem: key => {
            const value = storage.getString(key);
            return value ? parseOrNull(value) : defaultValue;
        },
        setItem: (key, value) => {
            storage.set(key, JSON.stringify(value));
        },
        removeItem: key => {
            storage.delete(key);
        },
    };
    return atomWithStorage(atomKey, defaultValue, valueStore, {
        getOnInit: true,
    });
}
